module.exports = __webpack_public_path__ + "static/media/noreports.6da6574e.png";